import React from "react";
import Products from "./Products";

export default function Function() {
    return (
        <div className="h-100 pb-5 c-light-2">           
            <div className="container w-75 h-100">
                <Products />
            </div>
        </div>
    );
}